module.exports = __webpack_public_path__ + "static/media/0_2019_03_02.4925884d.jpg";